export default {
    filters: {
        title: "Filtri",
        removeFilter: "Rimuovi il filtro",
        filterIntensity: "Intensità del filtro",
        duotone: {
            title: "Duotono",
            desert: "Deserto",
            peach: "Pesca",
            clash: "Scontro",
            plum: "Prugna",
            breezy: "Vento leggero",
            deepBlue: "Blu profondo",
            frog: "Rana",
            sunset: "Tramonto",
        },
        blackAndWhite: {
            title: "Bianco e Nero",
            ad: "1920 D.C",
            greyed: "Sfumato",
            dusty: "Polveroso",
            litho: "Lito",
            sepia: "Sepia",
            weathered: "Invecchiato",
            hardStuff: "Roba difficile",
        },
        vintage: {
            title: "Vintage",
            polaroid: "Polaroid",
            sunny: "Anni '70 soleggiati",
            oldTimer: "Vecchio Timer",
            inferno: "Inferno",
            snappy: "Scattante",
        },
        smooth: {
            title: "Liscio",
            chestnut: "Marrone",
            softy: "Perbenista",
            pebble: "Sasso",
            moss: "Muschio",
            lemon: "Limone",
            greenGap: "Spazio verde",
        },
        cold: {
            title: "Freddo",
            colla: "Colla",
            solanus: "Solanus",
            kalmen: "Kalmen",
            jorah: "Joran",
            levante: "Eastern",
            zephyr: "Zefiro",
        },
        warm: {
            title: "Caldo",
            golden: "Dorato",
            lowFire: "Basso fuoco",
            sunrise: "Alba",
            flatBack: "Schiena piatta",
            pumpkin: "Zucca",
        },
    },
};
